@if (label()) {
  <label class="label">
    <span [innerHTML]="label()"></span>
    @if (required()) {
      <span class="required">*</span>
    }
  </label>
}

@if (tooltip()) {
  <ix-tooltip
    class="tooltip"
    [header]="label() || ''"
    [message]="tooltip() || ''"
  ></ix-tooltip>
}
